var isString = require('lodash').isString;
var removeHtmlTags = require("ultra/helpers/text").removeHtmlTags;
export var isTgID = function (id) {
    if (!id)
        return false;
    if (isString(id)) {
        return id.indexOf("tg:") === 0;
    }
    return false;
};
export var formatTgID = function (id) {
    return "tg:" + id;
};
export var getTgID = function (id) {
    if (isTgID(id)) {
        return id.split("tg:")[1];
    }
    return null;
};
export var getUserProfilePhotos = function (fetch, bot_token, user_id, offset, limit) {
    var params = { "user_id": user_id };
    if (offset)
        params.offset = offset;
    if (limit)
        params.limit = limit;
    return new Promise(function (resolve, reject) {
        fetch("https://api.telegram.org/bot" + bot_token + "/getUserProfilePhotos", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "cache-control": "no-cache"
            },
            body: JSON.stringify(params)
        })
            .then(function (res) { return res.json(); })
            .then(function (res) {
            res.ok ? resolve(res) : reject(res);
        });
    });
};
export var getFile = function (fetch, bot_token, file_id) {
    var params = { "file_id": file_id };
    return new Promise(function (resolve, reject) {
        fetch("https://api.telegram.org/bot" + bot_token + "/getFile", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "cache-control": "no-cache"
            },
            body: JSON.stringify(params)
        })
            .then(function (res) { return res.json(); })
            .then(function (res) {
            res.ok ? resolve(res) : reject(res);
        });
    });
};
export var forwardMessage = function (fetch, bot_token, chat_id, from_chat_id, message_id) {
    return new Promise(function (resolve, reject) {
        var body = {
            "chat_id": chat_id,
            "from_chat_id": from_chat_id,
            "message_id": message_id
        };
        fetch("https://api.telegram.org/bot" + bot_token + "/forwardMessage", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "cache-control": "no-cache"
            },
            body: JSON.stringify(body)
        })
            .then(function (res) { return res.json(); })
            .then(function (res) {
            res.ok ? resolve(res.result) : reject(res);
        });
    });
};
export var sendMessage = function (fetch, bot_token, tg_chat_id, message, message_thread_id, keyboard, replay) {
    if (message_thread_id === void 0) { message_thread_id = undefined; }
    if (keyboard === void 0) { keyboard = false; }
    if (replay === void 0) { replay = false; }
    return new Promise(function (resolve, reject) {
        var limited_message = cleanHtmlTagsForPosting(message.substring(0, 3000));
        var body = {
            "disable_web_page_preview": true,
            "chat_id": tg_chat_id,
            "text": limited_message,
            "parse_mode": 'HTML'
        };
        if (keyboard && keyboard.length > 0) {
            body["reply_markup"] = {
                "inline_keyboard": keyboard
            };
        }
        if (message_thread_id) {
            body["message_thread_id"] = message_thread_id;
        }
        if (replay) {
            body["reply_to_message_id"] = replay;
        }
        fetch("https://api.telegram.org/bot" + bot_token + "/sendMessage", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "cache-control": "no-cache"
            },
            body: JSON.stringify(body)
        })
            .then(function (res) { return res.json(); })
            .then(function (res) {
            res.ok ? resolve(res.result) : reject(res);
        });
    });
};
export var sendPhoto = function (fetch, FormData, bot_token, tg_chat_id, file, message, message_thread_id, keyboard, show_caption_above_media, replay) {
    if (message_thread_id === void 0) { message_thread_id = undefined; }
    if (keyboard === void 0) { keyboard = false; }
    if (show_caption_above_media === void 0) { show_caption_above_media = undefined; }
    if (replay === void 0) { replay = false; }
    var LIMIT = 1000;
    return new Promise(function (resolve, reject) {
        if (!message) {
            reject({ message: "No caption" });
        }
        else {
            var body = new FormData();
            body.append('photo', file);
            body.append('chat_id', tg_chat_id);
            body.append('parse_mode', 'HTML');
            if (message_thread_id) {
                body.append('message_thread_id', message_thread_id);
            }
            if (replay) {
                body.append('reply_to_message_id', replay);
            }
            var visibleSymbols = removeHtmlTags(message).replaceAll("  ", " ").trim();
            console.log("visibleSymbols", visibleSymbols);
            if (visibleSymbols > LIMIT) {
                reject({ message: "Caption length exceeds limit of " + LIMIT + " visible characters" });
                return;
            }
            var clean_message = cleanHtmlTagsForPosting(message);
            body.append('caption', clean_message);
            if (show_caption_above_media) {
                body.append('show_caption_above_media', show_caption_above_media);
            }
            else {
                body.append('show_caption_above_media', 'True');
            }
            if (keyboard) {
                body.append('reply_markup', JSON.stringify({ "inline_keyboard": keyboard }));
            }
            fetch("https://api.telegram.org/bot".concat(bot_token, "/sendPhoto"), { method: "POST", body: body })
                .then(function (res) { return res.json(); })
                .then(function (res) {
                res.ok ? resolve(res.result) : reject(res);
            });
        }
    });
};
export var editMessageText = function (fetch, FormData, bot_token, tg_chat_id, message_id, message, keyboard) {
    var body = new FormData();
    console.log("editMessageText");
    body.append('chat_id', tg_chat_id);
    body.append('message_id', message_id);
    body.append('parse_mode', 'HTML');
    if (message) {
        body.append('text', cleanHtmlTagsForPosting(message.substring(0, 3000)));
    }
    if (keyboard) {
        body.append('reply_markup', JSON.stringify({ "inline_keyboard": keyboard }));
    }
    return new Promise(function (resolve, reject) {
        fetch("https://api.telegram.org/bot".concat(bot_token, "/editMessageText"), { method: "POST", body: body })
            .then(function (res) { return res.json(); })
            .then(function (res) {
            res.ok ? resolve(res.result) : reject(res);
        });
    });
};
export var editMessageCaption = function (fetch, FormData, bot_token, tg_chat_id, message_id, message, keyboard) {
    var body = new FormData();
    console.log("editMessageCaption");
    body.append('chat_id', tg_chat_id);
    body.append('message_id', message_id);
    body.append('parse_mode', 'HTML');
    if (message) {
        body.append('caption', cleanHtmlTagsForPosting(message.substring(0, 800)));
    }
    if (keyboard) {
        body.append('reply_markup', JSON.stringify({ "inline_keyboard": keyboard }));
    }
    return new Promise(function (resolve, reject) {
        fetch("https://api.telegram.org/bot".concat(bot_token, "/editMessageCaption"), { method: "POST", body: body })
            .then(function (res) { return res.json(); })
            .then(function (res) {
            res.ok ? resolve(res.result) : reject(res);
        });
    });
};
export var editMessageReplyMarkup = function (fetch, FormData, bot_token, tg_chat_id, message_id, keyboard) {
    if (keyboard === void 0) { keyboard = []; }
    var body = new FormData();
    console.log("editMessageReplyMarkup");
    body.append('chat_id', tg_chat_id);
    body.append('message_id', message_id);
    body.append('reply_markup', JSON.stringify({ "inline_keyboard": keyboard }));
    return new Promise(function (resolve, reject) {
        fetch("https://api.telegram.org/bot".concat(bot_token, "/editMessageReplyMarkup"), { method: "POST", body: body })
            .then(function (res) { return res.json(); })
            .then(function (res) {
            res.ok ? resolve(res.result) : reject(res);
        });
    });
};
export function cleanHtmlTagsForPosting(str) {
    if (!str)
        return "";
    str = str.toString();
    str = str.replaceAll("&nbsp;", " ");
    str = str.replaceAll("<p>", "");
    str = str.replaceAll("</p>", "\n\n");
    str = str.replaceAll("<br>", "\n");
    str = str.replaceAll("</br>", "\n");
    str = str.replaceAll("<ul>", "");
    str = str.replaceAll("</ul>", "\n\n");
    str = str.replaceAll("<ol>", "");
    str = str.replaceAll("</ol>", "\n\n");
    str = str.replaceAll("<li>", "- ");
    str = str.replaceAll("</li>", "\n");
    str = str.replaceAll("<h1>", "");
    str = str.replaceAll("</h1>", "\n\n");
    str = str.replaceAll("<h2>", "");
    str = str.replaceAll("</h2>", "\n\n");
    str = str.replaceAll("<h3>", "");
    str = str.replaceAll("</h3>", "\n\n");
    str = str.replaceAll("<h4>", "");
    str = str.replaceAll("</h4>", "\n\n");
    return str;
}
